import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

const META: Meta = {
  description: 'Event sent when a user completes the onboarding referral source step',
  name: 'Completed onboarding referral source',
  params: [
    {
      description: 'Selected referral source',
      name: 'answer',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the user skipped this step',
      name: 'skipped',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Custom answer when "Other" is selected',
      name: 'custom_response',
      required: false,
      type: 'string',
    },
    ONBOARDING_ANALYTICS_CATEGORY_META_PARAM,
  ],
};

export default META;
